import { Icon, Text, colors, radii, type IconName } from '@khaddi/ui';
import type { ReactNode } from 'react';
import { View } from 'react-native';

/** White card that overlaps the navy header, used for the non-offer home states. */
export const HeroCard = ({ icon, title, body, children, accent = colors.border }: { icon: IconName; title: string; body: string; children?: ReactNode; accent?: string }) => (
  <View
    style={{
      marginTop: -50,
      marginHorizontal: 16,
      backgroundColor: colors.surface,
      borderRadius: radii.xl,
      padding: 18,
      gap: 12,
      borderWidth: 2,
      borderColor: accent,
      boxShadow: '0 8px 24px rgba(28, 69, 95,.14)',
    }}
  >
    <View style={{ flexDirection: 'row', gap: 12, alignItems: 'center' }}>
      <View style={{ width: 48, height: 48, borderRadius: 24, backgroundColor: colors.surfaceMuted, alignItems: 'center', justifyContent: 'center' }}>
        <Icon name={icon} size={24} color={colors.primaryText} />
      </View>
      <View style={{ flex: 1, gap: 2 }}>
        <Text variant="heading">{title}</Text>
        <Text variant="caption" style={{ lineHeight: 18 }}>
          {body}
        </Text>
      </View>
    </View>
    {children}
  </View>
);
